






import { listFactory } from '@/main/pages';

import { openEdit } from '@/main/router/routerPath';

import { PageMode } from '@/main/utils/pageMode';
import { showAlert } from '@/main/utils/notifications';

import { apiProvider as InvoiceChargeTypeApiProvider } from './api';
import { NAME } from './constants';
import { store } from './store/list';

export default listFactory(NAME, store).extend({
	methods: {
		async editClick(event: any) {
			const { data: canEdit } = await InvoiceChargeTypeApiProvider.IsChargeTypeAlreadyUsed(event.data.INVOICE_CHARGE_TYPE_ID);
			if (!canEdit) {
				openEdit(NAME, PageMode.EDIT, { id: event.data.INVOICE_CHARGE_TYPE_ID });
			} else {
				showAlert({
					message: this.LocalizeChyboveHlasky('ItemCannotEidt'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
			}
		},
	},
});
